export const evaluationsConfigurationDefault = {
  filterName: "evaluations",
  filterValues: [
    {
      key: "assessment_type",
      value: "wound"
    },
    {
      key: "assessment_type",
      value: "braden,norton_plus,purs"
    },
    {
      key: "assessment_type",
      value: "full_body_skin"
    },
    {
      key: "assessment_type",
      value: "abpi"
    },
    {
      key: "assessment_type",
      value: "toe_pressure"
    },
    {
      key: "assessment_type",
      value: "hemoglobin"
    }
  ]
};
